import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import AuxiliaryEquipmentTable from './auxiliary-equipment-table';
import AuxiliaryEquipmentTile from './auxiliary-equipment-tile';
import AuxiliaryEquipmentSearch from './auxiliary-equipment-search';
import AuxiliaryEquipmentNavBar from './auxiliary-equipment-nav-bar';

const AuxiliaryEquipmentContent = props => {
  const [activeLane, setActiveLane] = useState('ALL');
  const tileView = useSelector(state => state.auxiliaryEquipment?.tileView ?? true);

  return (
    <div className="card table-list-card">
      <div className="card-body">
        <div className="table-top w-100">
          <AuxiliaryEquipmentSearch />
        </div>
        <div className="d-flex">
          <AuxiliaryEquipmentNavBar onLaneChange={setActiveLane} activeLane={activeLane} />
          {!tileView ? <AuxiliaryEquipmentTable activeLane={activeLane} /> : <AuxiliaryEquipmentTile />}
        </div>
      </div>
    </div>
  );
};

export default AuxiliaryEquipmentContent;
